import { render, staticRenderFns } from "./purchase-plan-delete-confirmation.vue?vue&type=template&id=51341a20&scoped=true&"
import script from "./purchase-plan-delete-confirmation.vue?vue&type=script&lang=js&"
export * from "./purchase-plan-delete-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan-delete-confirmation.vue?vue&type=style&index=0&id=51341a20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51341a20",
  null
  
)

export default component.exports